export default __webpack_public_path__ + "static/media/iphone_X_phone.3c127bb9.jpg";